import React, { Component } from "react";
import { connect } from "react-redux";
import * as authActions from "../../store/action/auth";
import Link from "src/components/link";
import "./layout.css";
import Cookies from "js-cookie";
import localStore from "src/utils/local-storage";
import ScreenSize from "../../services/screenSize";
import ReactDOM from "react-dom";
import UserAvatar from "react-user-avatar";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { toast } from "react-toastify";
import PostService from "../../services/PostService";
import ImageLoader from '../../components/image-loader/ImageLoader';
// import TagManager from 'react-gtm-module';
const IMG_SERVER = process.env.REACT_APP_IMG;
import { AdBlockDetectedWrapper } from "adblock-detect-react";
import { OverlayTrigger, Popover } from 'react-bootstrap';

const popover = (user) => {
  return (
    <Popover>
      <div className="layout-mobile" style={{ padding: "10px", width: "230px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <a href="/posts/new" type="button" className="btn btn-info btn-block" style={{marginTop: "5px", marginBottom: "5px"}}>
          Bài Thường
        </a>
        <a href="/posts/new?editor_type=mini" type="button" className="btn btn-danger btn-block" style={{marginTop: "5px", marginBottom: "5px"}}>
          Bài Mini
        </a>
        <a href="/posts/new?editor_type=special" type="button" className="btn btn-warning btn-block" style={{marginTop: "5px", marginBottom: "5px"}}>
          Bài Special
        </a>
        {user && (user.can_create_video_post || user.can_publish_video_post) &&
          <a href="/posts/new?editor_type=video" type="button" className="btn btn-dark btn-block" style={{marginTop: "5px", marginBottom: "5px"}}>
            Bài Video
          </a>
        }
        {/* {user && (user.can_create_podcast_post || user.can_publish_podcast_post) &&
          <a href="/posts/new?editor_type=podcast" className="btn btn-primary btn-block" style={{marginTop: "5px", marginBottom: "5px"}}>
            Bài Podcast
          </a>
        }
         {user && (user.can_create_short_post || user.can_publish_short_post) &&
          <a href="/posts/new?editor_type=short" className="btn btn-secondary btn-block" style={{marginTop: "5px", marginBottom: "5px"}}>
            Bài Short
          </a>
        } */}
      </div>
    </Popover>
  )
}
class HeaderComponent extends Component {
  isMobile = false;
  constructor() {
    super();
    this.state = {
      clickLoggout: false,
      user: {},
      scrollHeader: false,
      onHover: false
    };
    this.isMobile = ScreenSize.isMobile;
    this.tabTimeOut;
    this.tabsExpiry = setInterval(function () {
      const tabs = localStore.getExpiryTabs();
      if(tabs){
        tabs.map((e,index) => {
          localStore.remove("_" + e.value + "_current_id");
        })
      }
    }, 5 * 60 * 1000);
  }
  componentDidMount() {
    let user = localStore.get("_user");
    this.setState({ user });
    window.addEventListener("scroll", this.handleScroll.bind(this));
    // window.addEventListener("beforeunload", this.onUnload);
    // window.addEventListener("unload", this.onUnload);
    // window.addEventListener("blur", this.onBlur);
    window.addEventListener("focus", this.onFocus);
    // TagManager.initialize({ gtmId: 'GTM-KQPNZD2' });
    
  }

  onUnload = e => { // the method that will be used for both add and remove event

    e.preventDefault();
    if (window.location.pathname.includes("/posts/edit/")) {
      this.releasePost();
    }


    // e.returnValue = '';
  }
  onBlur = e => {
    // setTimeout
    console.log('onBlur tab');
    this.tabTimeOut = setTimeout(function () {
      console.log('releasePost');
      if (window.location.pathname.includes("/posts/edit/")) {
        if (localStore.get("_current_id") && localStore.get("_current_id") != 'NO STORAGE') {
          PostService.updatelock({
            editing_status: false,
            editing: null,
            start_editing: null,
            id: localStore.get("_current_id")
          });
          localStore.remove("_current_id");
        }
      }
    }, 15 * 60 * 1000);
    localStore.updateTabs();
  }
  onFocus = e => {
    // clearTimeout
    console.log('onFocus tab');
    if(this.tabTimeOut){
      clearTimeout(this.tabTimeOut);
    }
  }

  releasePost() {
    if (localStore.get("_current_id") && localStore.get("_current_id") != 'NO STORAGE') {
      PostService.updatelock({
        editing_status: false,
        editing: null,
        start_editing: null,
        id: localStore.get("_current_id")
      });
      localStore.remove("_current_id");
    }

  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("beforeunload", this.onUnload);
    window.removeEventListener("unload", this.onUnload);
    window.removeEventListener("onblur", this.onBlur);
    window.removeEventListener("onfocus", this.onFocus);
  }

  signOut = () => {
    this.setState({ clickLoggout: true });
    this.props.logoutPage();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { login: nextLogin, router: nextRouter } = nextProps;
    const { login, router } = this.props;

    if (login.userInfo !== nextLogin.userInfo && nextLogin.userInfo) {
      const user = nextLogin.userInfo;
      this.setState({ user });
    }

    if (localStore.get("_current_id") && (!nextRouter.location.pathname.includes("/posts/edit/") || !nextRouter.location.pathname.includes("/posts/new"))
    ) {
      if (localStore.get("_current_id") && localStore.get("_current_id") != 'NO STORAGE') {
        PostService.updatelock({
          editing_status: false,
          editing: null,
          start_editing: null,
          id: localStore.get("_current_id")
        });
        localStore.remove("_current_id");
      }

    }
    if (
      router.location.pathname == nextRouter.location.pathname &&
      router.location.search != nextRouter.location.search &&
      nextRouter.location.search == "?page=1&limit=20"
    ) {
      window.location.href =
        nextRouter.location.pathname + nextRouter.location.search;
    }

    if (
      (nextRouter.location.pathname.includes("/users")) &&
      localStore.get("_user").role.name != "SuperAdmin"
    ) {
      this.confirmAction();
    }
  }

  confirmAction() {
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes")
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1>Bạn không có quyền truy cập mục này.</h1>
          <div
            className="bg-c7c6c5 bg-c7c6c5 txt-center pt-3 pb-3"
            onClick={() => {
              onClose();
              window.location.href = "/";
            }}
          >
            Trở lại
          </div>
        </div>
      ),
      closeOnEscape: false,
      closeOnClickOutside: false
    };

    confirmAlert(options);
  }

  handleScroll() {
    let scroll = window.scrollY;
    if (scroll >= 10) {
      this.setState({ scrollHeader: true });
    } else {
      this.setState({ scrollHeader: false });
    }
  }

  hover(status) {
    // this.setState({ onHover: status });
  }
  changePostPage = () => {
    alert("hello");
  };
  uppercaseName(phrase) {
    phrase = phrase || "N";
    return phrase
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  render() {
    let user = localStore.get("_user");
    const userAvatar =
      this.state.user && this.state.user.avatar
        ? IMG_SERVER + "w60" + '/uploads/' + this.state.user.avatar.hash + this.state.user.avatar.ext
        : "";

    return (
      <>
        <AdBlockDetectedWrapper>
          <div className="adblock">
            <div className="adblock-content">
              <p>Để tránh các lỗi xảy ra trong quá trình sử dụng cms, các anh chị, các bạn vui lòng tắt Adblock</p>
              <p>Team cảm ơn các anh chị, các bạn.</p>
            </div>
          </div>
        </AdBlockDetectedWrapper>
        <div className="header-cms">
          <div
            className={
              "navigation-wrap bg-light start-header " +
              (this.state.scrollHeader ? "scroll-on" : "start-style")
            }
          >
            <div className="row">
              <div className="col-12">
                <nav className="navbar navbar-expand-md navbar-light">
                  <a className="navbar-brand" href="/">
                    <h1>SAOSTAR CMS</h1>
                  </a>

                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>

                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav mr-auto pt-4 py-md-0">
                      <li
                        className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1 btn-new-post"
                      >
                        <OverlayTrigger
                            trigger="click"
                            overlay={popover(this.state.user)}
                            placement="bottom"
                            rootClose={true}
                          >
                          <button type="button" className="nav-link w-100"><i className="fas fa-plus"></i> Viết bài mới</button>
                        </OverlayTrigger>
                      </li>
                      <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1" >
                        <Link
                          to={"/posts"}
                          className="nav-link w-100"
                        >
                          Danh sách bài viết
                        </Link>
                      </li>
                      {user && (user.can_publish_video_post || user.can_create_video_post) &&
                        <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1" >
                          <Link to={"/videos?editor_type=video&page=1&limit=20"} className="nav-link w-100" >
                            Video
                          </Link>
                        </li>
                      }
                      {/* {user && (user.can_publish_podcast_post || user.can_create_podcast_post) &&
                        <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1" >
                          <Link to={"/podcasts?editor_type=podcast&page=1&limit=20"} className="nav-link w-100" >
                            Podcasts
                          </Link>
                        </li>
                      } */}
                      {/* {user && (user.can_publish_short_post || user.can_create_short_post) &&
                        <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1" >
                          <Link to={"/shorts?editor_type=short&page=1&limit=20"} className="nav-link w-100" >
                            Shorts
                          </Link>
                        </li>
                      } */}

                      {user && user.role && user.role.name == "SuperAdmin" && (
                        <li
                          className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1"

                        >
                          <Link to={"/users"} className="nav-link w-100">
                            Tài Khoản
                        </Link>
                        </li>
                      )}
                      {/* doi tu superadmin to can_homepage */}
                      {/* {user && user.role && user.role.name == "SuperAdmin" && ( */}
                      {user && user.can_homepage && (
                        <li
                          className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1"

                        >
                          <Link to={"/home"} className="nav-link w-100">
                            Trang chủ
                        </Link>
                        </li>
                      )}
                      {user && user.can_view_royalties && (
                        <li
                          className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1"

                        >
                          <Link to={"/nhuan"} className="nav-link w-100">
                            Chấm nhuận
                        </Link>
                        </li>
                      )}
                      {user && user.can_view_ga && (
                        <li
                          className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1"

                        >
                          <Link to={"/ga?version=gav4s"} className="nav-link w-100">
                            Xem GAv4
                        </Link>
                        </li>
                      )}
                      <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1">
                        <Link to={"/realtime-posts"} className="nav-link w-100">
                          Realtime Posts
                        </Link>
                      </li>
                      {user && user.can_use_designer_tools && (
                        <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1">
                          <Link to={"/designer-tools"} className="nav-link w-100">
                            Dành cho Designer
                          </Link>
                        </li>
                      )}
                      {/* {user &&
                        <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1">
                          <Link to={"/review-seo"} className="nav-link w-100">
                            Review SEO
                          </Link>
                        </li>
                      } */}
                      {/* {user &&
                        <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1">
                          <Link to={"/crawled-posts"} className="nav-link w-100">
                            Crawled Posts
                          </Link>
                        </li>
                      } */}
                      {/* {user && user.role && user.role.name == "SuperAdmin" && (
                        <li
                          key={"header-noi-dung"}
                          className={
                            "nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1 " +
                            (this.state.onHover ? "show" : "")
                          }
                          onMouseEnter={() => this.hover(true)}
                          onMouseLeave={() => this.hover(false)}
                        >
                          <a
                            className="nav-link dropdown-toggle"
                            data-toggle="dropdown"
                            href="#"
                            role="button"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Nội dung <i className="fas fa-angle-down ml5"></i>
                          </a>
                          <div className="dropdown-menu">
                            <Link
                              to={"/categories"}
                              className="dropdown-item"
                            >
                              Danh mục
                          </Link>
                            <Link
                              to={"/tags"}
                              className="dropdown-item"
                            >
                              Tags
                          </Link>
                            <Link
                              to={"/content/pennames?page=1&limit=10"}
                              className="dropdown-item"
                            >
                              Bút danh
                          </Link>
                            <Link
                              to={"/content/photographer?page=1&limit=10"}
                              className="dropdown-item"
                            >
                              Photographer
                          </Link>
                            <Link
                              to={"/content/video?page=1&limit=10"}
                              className="dropdown-item"
                            >
                              Video
                          </Link>
                            <Link
                              to={"/content/designer?page=1&limit=10"}
                              className="dropdown-item"
                            >
                              Designer
                          </Link>
                            <Link
                              to={"/content/source?page=1&limit=10"}
                              className="dropdown-item"
                            >
                              Nguồn
                          </Link>
                            <Link
                              to={"/content/editor?page=1&limit=10"}
                              className="dropdown-item"
                            >
                              Biên tập viên
                          </Link>
                            <Link
                              to={"/content/photo?page=1&limit=10"}
                              className="dropdown-item"
                            >
                              Nhiếp ảnh
                          </Link>
                          </div>
                        </li>
                      )} */}
                    </ul>
                    <ul className="navbar-nav ml-auto py-md-0">
                      <li
                        key={"header-user"}
                        className={
                          "nav-item pl-4 pl-md-0 ml-0 ml-md-4 py-1 " +
                          (this.state.onHover ? "show" : "")
                        }
                        onMouseEnter={() => this.hover(true)}
                        onMouseLeave={() => this.hover(false)}
                      >
                        <a
                          className="nav-link dropdown-toggle user-panel image d-inline"
                          data-toggle="dropdown"
                          href="#"
                          role="button"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {user.avatar
                            ? <ImageLoader className="lazyload" src={user.avatar} width="100" />
                            :
                            <>
                              <UserAvatar
                                size="33"
                                name={this.uppercaseName(
                                  (this.state.user &&
                                    this.state.user.fullname) ||
                                  "NN"
                                )}
                                className="d-inline-block"
                                src={userAvatar}
                                colors={[
                                  "#ff6188",
                                  "#fc9867",
                                  "#ffd866",
                                  "#a9dc76",
                                  "#78dce8",
                                  "#ab9df2"
                                ]}
                              />
                              <i
                                className="fas fa-angle-down ml5"
                                style={
                                  userAvatar === ""
                                    ? { lineHeight: "33px" }
                                    : {
                                      lineHeight: "33px",
                                      verticalAlign: "text-bottom"
                                    }
                                }
                              ></i>
                            </>
                          }
                        </a>
                        <div className="dropdown-menu right">
                          {this.state.user && (
                            <a className="name">{this.state.user.fullname}</a>
                          )}
                          <Link to={"/profile"} className="dropdown-item">
                            <i className="fas fa-user"></i> Profile
                        </Link>
                          {(user && user.role && user.role.name == "SuperAdmin") && (
                            <Link to={"/config"} className="dropdown-item">
                              <i className="fas fa-cog"></i> Config
                            </Link>
                          )}

                          <a onClick={this.signOut} href="/login" className="dropdown-item" >
                            <i className="fas fa-th-large"></i> Logout
                        </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default connect(
  store => {
    return {
      login: store.loginInfo,
      router: store.router
    };
  },
  dispatch => {
    return {
      logoutPage: value => {
        dispatch(authActions.logout(value));
      }
    };
  }
)(HeaderComponent);
